import React, { useState, useRef } from "react"
import { Link } from "gatsby"

const Header = ({ siteTitle, allData }) => {
  const [searchQuery, setSearchQuery] = useState("")
  const [filteredResults, setFilteredResults] = useState([])
  const searchInputRef = useRef(null)

  const handleSearch = (event) => {
    const query = event.target.value.trim()
    setSearchQuery(query)

    if (!query) {
      setFilteredResults([])
      return
    }

    const filtered = allData.filter(
      (item) =>
        item.name &&
        item.name.toLowerCase().includes(query.toLowerCase()) &&
        item.amount > 0
    )

    setFilteredResults(filtered)
  }

  const toggleMenu = () => {
    const menu = document.querySelector(".menu")
    menu.classList.toggle("open")
  }

  return (
    <header>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Link to="/" className="logo">
          {siteTitle}
        </Link>
      </div>
      <div className="header-search">
        <input
          type="text"
          placeholder="Sök namn, efternamn eller djur..."
          value={searchQuery}
          onChange={handleSearch}
          className="search-input"
          ref={searchInputRef}
          id="header-search"
        />
        {searchQuery && (
          <ul className="search-results">
            {filteredResults.map((item, index) => (
              <li key={index} className="search-result-item">
                <Link
                  to={`/${
                    item.type === "Förnamn"
                      ? "namn"
                      : item.type === "Efternamn"
                      ? "efternamn"
                      : "djur"
                  }/${item.name.toLowerCase()}`}
                  className="search-result-link"
                >
                  <span>{item.name}</span>
                  <span className="result-type">{item.type}</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
      <nav className="menu">
        <Link
          to="/topplistor"
          style={{
            fontSize: `var(--font-md)`,
            marginRight: `var(--space-3)`,
          }}
        >
          Topplistor
        </Link>
        <Link
          to="/namn"
          style={{
            fontSize: `var(--font-md)`,
            marginRight: `var(--space-3)`,
          }}
        >
          Förnamn
        </Link>
        <Link
          to="/efternamn"
          style={{
            fontSize: `var(--font-md)`,
            marginRight: `var(--space-3)`,
          }}
        >
          Efternamn
        </Link>
        <Link
          to="/djur"
          style={{
            fontSize: `var(--font-md)`,
          }}
        >
          Djur
        </Link>
      </nav>
      <button className="menu-toggle" onClick={toggleMenu}>
        ☰
      </button>
    </header>
  )
}

export default Header